var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ELSAdobeAnalyticService, ELSCommonUIConstants } from '@els/els-ui-common-react';
import { ELSLoggingService } from 'components/common';
var INVALID_PAGEDATA_MSG = 'pageData not available or invalid for analytics';
export var trackAAEvent = function (eventType, analyticsObj) {
    if (!window.pageData || typeof window.pageData !== 'object') {
        ELSLoggingService.warn('AA Init', INVALID_PAGEDATA_MSG);
        return;
    }
    try {
        var aaPageData = window.pageData;
        var locVisitorObj_1 = aaPageData.visitor;
        var locPageObj_1 = aaPageData.page;
        var locEducationObj_1 = aaPageData.education;
        var locAnalyticsObj_1 = analyticsObj;
        var analyticsObjKeys = Object.keys(locAnalyticsObj_1);
        var pageKeys_1 = Object.keys(aaPageData.page);
        var visitorKeys_1 = Object.keys(aaPageData.visitor);
        analyticsObjKeys.forEach(function (analyticsKey) {
            if (visitorKeys_1.includes(analyticsKey)) {
                locVisitorObj_1[analyticsKey] = locAnalyticsObj_1[analyticsKey];
                delete locAnalyticsObj_1[analyticsKey];
            }
            if (pageKeys_1.includes(analyticsKey)) {
                locPageObj_1[analyticsKey] = locAnalyticsObj_1[analyticsKey];
                delete locAnalyticsObj_1[analyticsKey];
            }
            if (pageKeys_1.includes(analyticsKey)) {
                locEducationObj_1[analyticsKey] = locAnalyticsObj_1[analyticsKey];
                delete locAnalyticsObj_1[analyticsKey];
            }
        });
        ELSAdobeAnalyticService.trackEvent(eventType, __assign(__assign(__assign({}, locAnalyticsObj_1), aaPageData), { visitor: locVisitorObj_1, page: locPageObj_1, education: locEducationObj_1 }));
    }
    catch (error) {
        ELSLoggingService.error('AA Error', "Failed to track event: ".concat(error));
    }
};
export var trackAAFeature = function (feature, payload) {
    if (!window.pageData || typeof window.pageData !== 'object') {
        ELSLoggingService.warn('AA Init', INVALID_PAGEDATA_MSG);
        return;
    }
    try {
        ELSAdobeAnalyticService.trackEvent(ELSCommonUIConstants.analytics.eventTypes.productFeatureUsed, __assign(__assign({}, window.pageData), { feature: __assign({ name: feature }, payload) }));
    }
    catch (error) {
        ELSLoggingService.error('AA Error', "Failed to track feature: ".concat(error));
    }
};
export var trackAAPageView = function (pageName, pageProductName) {
    if (!window.pageData || typeof window.pageData !== 'object') {
        ELSLoggingService.warn('AA Init', INVALID_PAGEDATA_MSG);
        return;
    }
    try {
        // Directly update window.pageData.page so the CDN tracker reads the correct
        // values whether it accesses our passed object or window.pageData directly.
        window.pageData.page = __assign(__assign(__assign({}, window.pageData.page), { name: pageName }), (pageProductName && { productName: pageProductName }));
        // Pass a shallow copy of page so the library's internal mutation
        // (pageData.page.eventName = eventName) does not pollute window.pageData.page.
        ELSAdobeAnalyticService.trackEvent(ELSCommonUIConstants.analytics.eventTypes.newPage, __assign(__assign({}, window.pageData), { page: __assign({}, window.pageData.page) }));
    }
    catch (error) {
        ELSLoggingService.error('AA Error', "Failed to track page view: ".concat(error));
    }
};
